import React from "react"
import { Box } from "@mui/material"
import LaunchIcon from "@mui/icons-material/Launch"
import styles from "./ModalDefault.module.scss"

export interface ModalCommonTemplateProps {
  title?: string
  read1?: string
  read2?: string
  url?: string
}
/**
 * モーダルの共通テンプレート（引数として文字列・URLを渡す）
 * @param {string} title - モーダルのタイトル
 * @param {string} read1 - モーダルに表示する文字列①
 * @param {string} read2 - モーダルに表示する文字列②
 * @param {string} url - 「詳細はこちら」のリンク
 */
const ModalCommonTemplate = ({ title, read1, read2, url }: ModalCommonTemplateProps) => {
  const detail = () => {
    return (
      <>
        <br />
        <br />
        <span className={styles.detailLink}>
          詳細は
          <a href={url} target="_blank" rel="noreferrer">
            こちら
            <LaunchIcon className={styles.externalLink} />
          </a>
        </span>
      </>
    )
  }
  return (
    <>
      <Box className={styles.modalTitle}>
        <h3>{title}</h3>
      </Box>
      <Box className={styles.modalParagraph}>
        <p>
          {read1}
          {!read2 && url && detail()}
          <br />
          {read2 && read2}
          {read2 && url && detail()}
        </p>
      </Box>
    </>
  )
}

export default ModalCommonTemplate
